export const contact_info = {
    phone: '1 (888) 966-4655',
    sms: '1 (415) 582-6613',
    support_email: 'support@aven.com',
    job_email: 'jobs@aven.com',
}
